import { FAQTypeCategory } from "../../types";

const FAQsData: FAQTypeCategory = [
  {
    category: "faqs.categories.costaRicaEssentials.title",
    questions: [
      {
        id: 1,
        question: "faqs.categories.costaRicaEssentials.questions.1.question",
        answer: "faqs.categories.costaRicaEssentials.questions.1.answer",
        interLink: ["faqs.categories.costaRicaEssentials.questions.1.interLink"],
        interLinkText: ["faqs.categories.costaRicaEssentials.questions.1.interLinkText"],
      },
      {
        id: 2,
        question: "faqs.categories.costaRicaEssentials.questions.2.question",
        answer: "faqs.categories.costaRicaEssentials.questions.2.answer",
      },
      {
        id: 3,
        question: "faqs.categories.costaRicaEssentials.questions.3.question",
        answer: "faqs.categories.costaRicaEssentials.questions.3.answer",
      },
      {
        id: 4,
        question: "faqs.categories.costaRicaEssentials.questions.4.question",
        answer: "faqs.categories.costaRicaEssentials.questions.4.answer",
        interLink: ["faqs.categories.costaRicaEssentials.questions.4.interLink"],
        interLinkText: ["faqs.categories.costaRicaEssentials.questions.4.interLinkText"],
      },
    ],
  },
  {
    category: "faqs.categories.wildlifeNature.title",
    questions: [
      {
        id: 5,
        question: "faqs.categories.wildlifeNature.questions.5.question",
        answer: "faqs.categories.wildlifeNature.questions.5.answer",
        interLink: ["faqs.categories.wildlifeNature.questions.5.interLink"],
        interLinkText: ["faqs.categories.wildlifeNature.questions.5.interLinkText"],
      },
    ],
  },
  {
    category: "faqs.categories.toursServices.title",
    questions: [
      {
        id: 6,
        question: "faqs.categories.toursServices.questions.6.question",
        answer: "faqs.categories.toursServices.questions.6.answer",
      },
      {
        id: 7,
        question: "faqs.categories.toursServices.questions.7.question",
        answer: "faqs.categories.toursServices.questions.7.answer",
      },
      {
        id: 8,
        question: "faqs.categories.toursServices.questions.8.question",
        answer: "faqs.categories.toursServices.questions.8.answer",
        interLink: ["faqs.categories.toursServices.questions.8.interLink"],
        interLinkText: ["faqs.categories.toursServices.questions.8.interLinkText"],
      },
      {
        id: 9,
        question: "faqs.categories.toursServices.questions.9.question",
        answer: "faqs.categories.toursServices.questions.9.answer",
      },
      {
        id: 10,
        question: "faqs.categories.toursServices.questions.10.question",
        answer: "faqs.categories.toursServices.questions.10.answer",
      },
      {
        id: 11,
        question: "faqs.categories.toursServices.questions.11.question",
        answer: "faqs.categories.toursServices.questions.11.answer",
        interLink: ["faqs.categories.toursServices.questions.11.interLink", "faqs.categories.toursServices.questions.11.interLink2"],
        interLinkText: ["faqs.categories.toursServices.questions.11.interLinkText", "faqs.categories.toursServices.questions.11.interLinkText2"],
      },
    ],
  },
];

export default FAQsData;